import type { PivotLoadedDays } from '@ztechapps/common.contract'
import type { PivotData } from './types'
import { PivotFieldTypeEnum } from '@ztechapps/common.contract'
import { toPivotMemberKey } from './pivotMember.utils'

/** First and last local day per date field among the loaded rows — a field with no dated row is omitted. */
export const listPivotLoadedDays = ({ data, timeZone }: { data: PivotData; timeZone: string }): PivotLoadedDays[] => {
  const indexByName = new Map(data.fields.map((field, index) => [field.name, index]))
  return data.fields.flatMap((field) => {
    if (field.type !== PivotFieldTypeEnum.Date) return []
    const index = indexByName.get(field.name) as number
    let from: string | undefined
    let to: string | undefined
    data.rows.forEach((row) => {
      const day = toPivotMemberKey(row[index], field, undefined, timeZone)
      if (day === '') return
      if (from === undefined || day < from) from = day
      if (to === undefined || day > to) to = day
    })
    return from !== undefined && to !== undefined ? [{ field: field.name, from, to }] : []
  })
}
